module.exports = __webpack_public_path__ + "img/ABT.3b3d4c55.svg";